import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

type InnerFormPasswordLessStyling = {
  container: AbgSxProps;
  ctaContainer: AbgSxProps;
  rememberMe: AbgSxProps;
  forgotLink: AbgSxProps;
  logInBtn: AbgSxProps;
  simplifiedForgotLink: AbgSxProps;
  simplifiedSubmitBtn: AbgSxProps;
  inputHeight: AbgSxProps;
  forgotLinksWrapper: AbgSxProps;
  divider: AbgSxProps;
};

export const innerFormStyling: InnerFormPasswordLessStyling = {
  container: {
    rowGap: '16px',
  },
  ctaContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    columnGap: '20px',
  },
  rememberMe: {
    marginTop: '8px',
    '.MuiFormControlLabel-root': {
      margin: 0,
    },
    '.MuiButtonBase-root': {
      padding: 0,
      marginRight: '8px',
    },
    '.MuiBox-root': {
      width: '16px',
      height: '16px',
      borderColor: paletteBase.lowContrastStroke,
    },
  },
  forgotLink: {
    marginTop: '12px',
  },
  logInBtn: {
    width: '100%',
    marginTop: '24px',
    boxShadow: 'none',
  },
  simplifiedForgotLink: {
    display: 'flex',
    alignItems: 'center',
    height: 56,
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#000',
    mt: { xs: 0, md: '24px !important' },
  },
  simplifiedSubmitBtn: {
    minWidth: 150,
    height: 56,
    mt: { xs: 0, md: '24px !important' },
  },
  inputHeight: {
    '& .MuiInputBase-root': { height: 56 },
  },
  forgotLinksWrapper: {
    margin: '18px 0',
  },
  divider: {
    borderColor: paletteBase.black,
  },
};
